import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useModalStore } from '@features/modal'

import useDeliveryModal from '@widgets/modal-delivery/ui/useDeliveryModal'


import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function OrderAddressModal () {
  const { t: tc } = useTranslation('common')
  const { t: to } = useTranslation('order')
  const { closeModal } = useModalStore()
  const isTablet = useMediaQuery('(max-width: 991px)')
  const navigate = useNavigate()
  const { openDeliveryModal } = useDeliveryModal()
  const handleButtonClick = () => {
    closeModal('orderAddress')
    openDeliveryModal(() => navigate('/cart'))
  }

  const handleButtonClose = () => {
    closeModal('orderAddress')
  }
  return (
    <div className={styles.root}>
      <span>{to('addressChange.notice')}</span>
      <div className={styles.root__buttons}>
        <Button
          size={isTablet ? 'medium' : 'large'}
          onClick={handleButtonClick}
        >
          {tc('change')}
        </Button>
        <Button
          onClick={handleButtonClose}
          size={isTablet ? 'medium' : 'large'}
          theme="grey"
        >
          {tc('cancel.2')}
        </Button>
      </div>
    </div>
  )
}
